import {
  getDict
} from '@/api/dict'
import {
  objectMerge
} from '@/utils'

const dict = {
  state: {
    dictdata: null
  },

  mutations: {
    SET_DICT: (state, dictdata) => {
      state.dictdata = {}
      dictdata.forEach(v => {
        objectMerge(state.dictdata, v)
      })
    }
  },

  actions: {
    async GetDict({
      commit
    }) {
      const { data } = await getDict()
      commit('SET_DICT', data || [])
    }
  }
}

export default dict



// WEBPACK FOOTER //
// ./src/store/modules/dict.js